import styles from './AudioControl.module.css';

/**
 * The most reused motif in the system (§ 10): 5 to 7 bars, full radius,
 * asymmetric heights with the peak off-centre.
 *
 * It is STYLISED, not real audio analysis, and must not pretend otherwise —
 * the heights below are fixed, and the animation is a loop rather than a
 * reading of the signal.
 *
 * Decorative, so it stays out of the accessibility tree (§ 12). The state it
 * illustrates is announced by AudioControl in text.
 */

/* Seven bars, peak off-centre — deliberately not symmetric. */
const BAR_HEIGHTS = [0.26, 0.52, 0.82, 1, 0.66, 0.88, 0.36];

export function Waveform({ animated }: { animated: boolean }) {
  return (
    <span className={styles.waveform} data-animated={animated} aria-hidden="true">
      {BAR_HEIGHTS.map((height, index) => (
        <span
          key={index}
          className={styles.bar}
          style={{ '--bar-height': `${height * 100}%`, '--bar-index': index } as React.CSSProperties}
        />
      ))}
    </span>
  );
}
